import AdvancedController from "./advanced-controller"

export default class WocommerceImageVariantsController extends AdvancedController {

  static targets = ['variantImageSelector']

  onChange(event) {
    const variantSelectBox = document.getElementById(event.params.target)
    variantSelectBox.value = event.params.value
    variantSelectBox.click();

    const form = document.querySelector('.variations_form')
    form.dispatchEvent(new Event('update_variation_values'));

    const variationsForm = document.querySelector('form.variations_form');
    variationsForm.dispatchEvent(new Event('check_variations'));

    this.variantImageSelectorTarget.querySelectorAll('label').forEach((label) => {
      label.classList.remove('-selected');
    });
    event.target.parentElement.classList.add('-selected');

  }

}